import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import TaxAccoountEditStepPAN from "../../../../../components/Accounts/TaxAccount/TaxAccountEdit/TaxAccoountEditStepPAN";
import { useGstVerification } from "../../../../../components/verification/hooks/useGstVerification";
import { usePanVerification } from "../../../../../components/verification/hooks/usePanVerification";
import {
  editTaxCompliantAccountDetails,
  resetTaxEditDetails,
} from "../../../../../redux/features/accounts/taxAccount/taxAccountCreateEdit";
import { taxCompliantAccountDetail } from "../../../../../redux/features/accounts/taxAccount/taxAccountDetails";
import { resetGSTVerification } from "../../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  beneLookUp,
  resetPANVerification,
} from "../../../../../redux/features/verifyPAN/verifyPAN";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../../utils/configurationProvider";
import Validation from "../../../../../utils/validation";

const TaxationAccountEditPAN = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const prevPanRef = useRef("");
  const retryCountRef = useRef(0);
  const verifyDebounceRef = useRef(null);
  const [payload, setPayload] = useState({
    bank_account: "",
    ifsc_code: "",
    contact_no: "",
    email_id: "",
    gstin: "",
    name: "",
    categories: "",
    panNumber: "",
    newGstValue: "",
  });
  const [allData, setAllData] = useState([]);
  const [updatedGst, setUpdatedGst] = useState({
    id: "",
    panNo: "",
    gstNo: "",
  });
  const [isActive, setIsActive] = useState(false);
  const [isDennied, setIsDennied] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [hideBlock, setHideBlock] = useState(false);
  const [isAchived, setIsArchived] = useState(false);
  const [lookupNext, setLookupNext] = useState(false);
  const [hideCreate, setHideCreate] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [customErrors, setCustomErrors] = useState({});
  const [activeTab, setActiveTab] = useState("Active");
  const [taxAccountId, setTaxAccountId] = useState("");
  const [openPopEdit, setOpenPopEdit] = useState(false);
  const [updateActive, setUpdateActive] = useState(false);
  const [previousBankNo, setPreviousBankNo] = useState("");
  const [alreadyLinked, setAlreadyLinked] = useState(false);
  const [isApprovedState, setIsApprovedState] = useState([]);
  const [isNextDisabled, setIsNextDisabled] = useState(false);
  const [slideDirection, setSlideDirection] = useState("right");
  const [isLinkedAccount, setIsLinkedAccount] = useState(false);
  const [openPopEditCheck, setOpenPopEditCheck] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [disableCreateNext, setDisableCreateNext] = useState(false);
  const [taxAccountDetails, setTaxAccountDetails] = useState(false);
  const [accountType, setAccountType] = useState({ type: "", id: "" });
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const specialRegex = /^[a-zA-Z0-9 ]*$/;

  const {
    loading: isGSTLoading,
    details: gstDetails,
    status: GSTStatus,
    error: GSTError,
    GSTLinked,
    gstVerified,
  } = useGstVerification(payload.gstin, payload.panNumber);

  const {
    verified: verifiedPan,
    details: panDetails,
    loading: verifyPANisLoading,
  } = usePanVerification(payload.panNumber);

  const { services, isLoading } = useSelector((state) => state.refreshToken);

  const { beneLookData, beneLookLoading } = useSelector(
    (state) => state.verify,
  );

  const { taxAccountEditOtherDetailsData } = useSelector(
    (state) => state.taxCompliantAccounts,
  );
  const { taxCompliantDetailsData, taxCompliantDetailsLoading } = useSelector(
    (state) => state.taxCompliantAccountDetail,
  );

  const [associatedPan, setAssociatedPan] = useState(true);

  const isPanLengthValid =
    payload.panNumber?.length === GlobalConfiguration.panLength;

  const isButtonEnabled =
    isPanLengthValid &&
    verifiedPan === true &&
    !verifyPANisLoading &&
    !isNextDisabled &&
    !updateActive &&
    !disableCreateNext;

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      previousEnableBgColor: "var(--primary-nav-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      previousEnableTextColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      nextIsEnabled: isButtonEnabled,
      previousIsDisabled: updateActive,
      nextIsLoading: updateActive,
      nextLoaderNeeded: true,
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: updateActive
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableTextColor: "var(--text-primary)",
      stepperText: "PAN details",
    },
  ];

  let haveAcheived = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "archived";
  });
  let haveApproved = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "approved";
  });
  let haveDennied = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "denied";
  });
  let haveRejected = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "rejected";
  });
  let havePending = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "pending";
  });
  let haveBlock = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "blocked";
  });

  let haveLinkNew = allData?.some((val) => {
    return val?.bank_acc_no === previousBankNo && val?.id !== id;
  });

  const noDetails =
    beneLookData?.beneficiary_accounts &&
    beneLookData?.beneficiary_accounts?.length > 0;

  const prefilledPan = taxCompliantDetailsData?.tds_accounts?.[0]?.pan_no || "";

  const prefilledGst =
    taxCompliantDetailsData?.tds_accounts?.[0]?.gstin_detail || "";

  const resetLinkedState = () => {
    setIsLinkedAccount(false);
    setAlreadyLinked(false);
    setIsApprovedState([]);
    setTaxAccountId("");
    setAllData([]);
  };

  const clearDebounce = () => {
    if (verifyDebounceRef.current) {
      clearTimeout(verifyDebounceRef.current);
      verifyDebounceRef.current = null;
    }
  };
  const modifyValue = (type, value) => {
    if (type === "name") {
      return value?.replace(/(\w)(\w*)/g, function (g1, g2) {
        return g1.toUpperCase() + g2.toLowerCase();
      });
    } else if (type === "gstin") {
      return value?.toUpperCase();
    }
    return value.trim();
  };

  const allowedValue = (name, value) => {
    if (name === "gstin") return Validation.allowedGstin(value);
    return true;
  };
  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };

    if (name === "gstin")
      errors = Validation.validateGstin(name, value, errors);
    setCustomErrors(errors);
  };

  const handlePANChange = (e) => {
    setHasUnsavedChanges(true);
    const inputPan = e.target.value.toUpperCase();

    if (!specialRegex.test(inputPan)) return;
    if (inputPan.length > GlobalConfiguration.panLength) return;

    if (inputPan.length < 10) {
      resetLinkedState();
      setOpenPopEditCheck(true);
      clearDebounce();
      retryCountRef.current = GlobalConfiguration.lengthCheckZero;
      setIsNextDisabled(false);
      setLookupNext(false);
      setAccountType({ type: "", id: "" });
      sessionStorage.removeItem("PAN GST Edit NewValue");
    }

    if (
      inputPan.length === GlobalConfiguration.panLength &&
      !panRegex.test(inputPan)
    ) {
      setPayload((prev) => ({
        ...prev,
        panNumber: inputPan,
        gstin: "",
      }));

      return;
    }

    if (inputPan.length === GlobalConfiguration.panLength) {
      clearDebounce();
      verifyDebounceRef.current = setTimeout(() => {
        retryCountRef.current = GlobalConfiguration.lengthCheckZero;
      }, IntervalConfiguration.intervalMedium);

      setAllData([]);
    }

    if (taxCompliantDetailsData?.tds_accounts?.[0]?.pan_no === inputPan) {
      setOpenPopEditCheck(false);
    }

    setPayload((prev) => ({
      ...prev,
      panNumber: inputPan,
      gstin: "",
    }));

    setAccountType({ type: "", id: "" });
    setIsLinkedAccount(false);
    setIsArchived(false);
    setIsApproved(false);
    setIsDennied(false);
    setIsPending(false);
    setIsActive(false);
    setHideBlock(false);
    setHideCreate(false);
    setAlreadyLinked(false);
    setDisableCreateNext(false);
  };

  const handleGSTChange = (e) => {
    if (!payload.panNumber || !verifiedPan) return;
    setHasUnsavedChanges(true);
    const { name, value } = e.target;
    const newValue = modifyValue(name, value.replace(/[^a-zA-Z0-9]/g, ""));

    if (allowedValue(name, value)) {
      validateAndRecordError(name, newValue);
      setPayload((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));

      if (value.trim() === "" && value?.length === 1) {
        return;
      }
    }
  };
  const handleBack = () => {
    if (!hasUnsavedChanges) {
      navigate(
        `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/${id}`,
      );
    } else {
      setOpenPopEdit(true);
    }
  };

  const handleConfirm = () => {
    navigate(
      `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/${id}`,
    );
  };

  const closeGSTDetailsModal = () => {
    setShowPopup(false);
  };

  const handleUpdateAccount = async () => {
    if (updateActive) return;

    setUpdateActive(true);

    try {
      await dispatch(
        editTaxCompliantAccountDetails({
          id,
          requestBody: {
            tds_accounts: {
              id,
              pan: payload.panNumber,
              gstin: payload.gstin,
              type_of_account: "tds",
            },
          },
        }),
      ).unwrap();
    } catch (err) {
      console.log("Update Failed", err);
    } finally {
      setUpdateActive(false);
    }
  };

  useEffect(() => {
    if (prevPanRef.current !== payload.panNumber) {
      dispatch(resetGSTVerification());
      prevPanRef.current = payload.panNumber;
    }

    if (!payload.panNumber || payload.panNumber.length < 10) {
      dispatch(resetPANVerification());
      resetLinkedState();

      setPayload((prev) => ({
        ...prev,
        gstin: "",
      }));
    }
  }, [payload.panNumber]);

  useEffect(() => {
    if (!beneLookData?.beneficiary_accounts) return;

    const current = beneLookData.beneficiary_accounts.find(
      (val) => val.id === id,
    );

    if (current?.gstin_detail && !payload.panNumber && !payload.gstin) {
      setPayload((prev) => ({
        ...prev,
        gstin: current.gstin_detail,
      }));
    }
  }, [beneLookData, id]);

  useEffect(() => {
    if (beneLookData?.beneficiary_accounts?.length > 0) {
      const hasId = beneLookData.beneficiary_accounts.some(
        (val) => val.id === id,
      );

      setAssociatedPan(hasId);
    }
  }, [beneLookData, id]);

  useEffect(() => {
    const fetchPANData = async () => {
      let response = await dispatch(taxCompliantAccountDetail(id));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchPANData();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    sessionStorage.setItem("Pan Gst Verification", JSON.stringify(updatedGst));
  }, [updatedGst]);

  useEffect(() => {
    if (
      !taxCompliantDetailsLoading &&
      taxCompliantDetailsData?.status === true
    ) {
      const account = taxCompliantDetailsData?.tds_accounts?.[0];
      setUpdatedGst({
        id: account?.id,
        panNo: account?.pan_no,
        gstNo: account?.gstin_detail,
      });

      setPayload((prev) => ({
        ...prev,
        panNumber: account?.pan_no,
        gstin: account?.gstin_detail,
      }));
    }
  }, [taxCompliantDetailsData]);

  useEffect(() => {
    const enteredPan = payload.panNumber || "";
    const enteredGst = payload.gstin || "";

    const wasGstPreviouslyLinked = !!prefilledGst;
    const isGstCurrentlyEntered = !!enteredGst;

    const isPanCompletelyValid =
      enteredPan.length === 10 && verifiedPan === true && !verifyPANisLoading;

    const isEnteredGstValidAndLinked =
      !isGstCurrentlyEntered ||
      (enteredGst.length === 15 && gstVerified === true && GSTLinked === true);

    const isNoChangeFromOriginalDetails =
      enteredPan === prefilledPan && enteredGst === prefilledGst;

    const isUserRemovingPreviouslyLinkedGst =
      wasGstPreviouslyLinked && !isGstCurrentlyEntered;

    const isEnteredGstNotLinkedToPan =
      isGstCurrentlyEntered && GSTLinked === false;

    const isUpdateActionBlocked =
      !isPanCompletelyValid ||
      !isEnteredGstValidAndLinked ||
      isNoChangeFromOriginalDetails ||
      isUserRemovingPreviouslyLinkedGst ||
      isEnteredGstNotLinkedToPan;

    setIsNextDisabled(isUpdateActionBlocked);
  }, [
    payload.panNumber,
    payload.gstin,
    verifiedPan,
    verifyPANisLoading,
    gstVerified,
    GSTLinked,
    prefilledPan,
    prefilledGst,
  ]);

  useEffect(() => {
    if (taxAccountEditOtherDetailsData?.status === true) {
      const prev = taxCompliantDetailsData?.tds_accounts?.[0];

      const updatedFields = [];

      if (prev?.pan_no !== payload.panNumber) {
        updatedFields.push("pan_no");
      }

      if ((prev?.gstin_detail || "") !== (payload.gstin || "")) {
        updatedFields.push("gstin_detail");
      }

      if (!updatedFields.length) {
        updatedFields.push("pan_no");
      }

      navigate(
        `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/pan_edit_success/${id}`,
        {
          state: { updatedFields },
          replace: true,
        },
      );

      dispatch(resetTaxEditDetails());
      dispatch(resetPANVerification());
    }
  }, [taxAccountEditOtherDetailsData]);

  useEffect(() => {
    if (!isLoading && services != null) {
      if (!services?.includes("BUAccount") && !services?.includes("Admin")) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "BUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  useEffect(() => {
    if (verifiedPan === true && payload.panNumber?.length === 10) {
      dispatch(
        beneLookUp({
          pan_number: payload.panNumber,
        }),
      );
    }
  }, [verifiedPan, payload.panNumber]);

  useEffect(() => {
    let haveApprovedLinked = beneLookData?.beneficiary_accounts?.filter(
      (val) => {
        return val?.id === id;
      },
    );

    let haveApprovedNotLinked = beneLookData?.beneficiary_accounts?.filter(
      (val) => {
        return val?.id !== id;
      },
    );

    if (haveApprovedLinked && haveApprovedNotLinked) {
      const newData = [...haveApprovedLinked, ...haveApprovedNotLinked];
      setIsApprovedState(newData);
    }
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {
    const current = beneLookData?.beneficiary_accounts?.find(
      (val) => val?.id === id,
    );
    if (current) {
      setPreviousBankNo(current?.bank_acc_no);
    }
  }, [beneLookData?.beneficiary_accounts, id]);

  useEffect(() => {
    if (gstDetails?.business_name) {
      setPayload((prev) => ({
        ...prev,
        gst_org_name: gstDetails?.business_name,
      }));
    }
  }, [gstDetails]);

  useEffect(() => {
    if (activeTab === "Active") {
      setIsActive(false);
      setIsApproved(false);
      setIsArchived(false);
      setIsDennied(false);
      setIsPending(false);
    } else if (activeTab === "Inactive") {
      setIsActive(true);
      setIsApproved(false);
      setIsArchived(false);
      setIsDennied(false);
      setIsPending(false);
    }
  }, [activeTab]);

  useEffect(() => {
    if (taxCompliantDetailsData?.tds_accounts?.[0]) {
      setHasUnsavedChanges(false);
    }
  }, [taxCompliantDetailsData]);

  return (
    <>
      {openPopEdit && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={"Are you sure you want to leave this page?"}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="Leaving this page will exit you from current flow."
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setOpenPopEdit(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleConfirm}
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div className="w-width-full flex justify-start items-center flex-col Qlg:bg-primary-bg bg-primary-nav overflow-hidden h-screen">
        <div className="min-h-navbar-breadcrumb-height hidden Qsmd:block"></div>
        <div
          className={`w-width-full flex h-full Qlg:h-full-height bg-primary-bg overflow-hidden ${!beneLookLoading && verifiedPan === true ? "" : " h-full-height"} `}
          style={{
            overflowY: openPopEdit ? "hidden" : "",
            height: openPopEdit ? "var(--full-height)" : "",
          }}
        >
          <div className="relative w-full flex flex-col overflow-hidden">
            <div className="Qsmd:hidden sticky top-top-base z-z-index-header">
              <TopNavComponent
                isFormattingNotRequired={true}
                topNavHeader="Tax Account"
                topNavSubText="PAN details"
              />
            </div>
            <div className="flex justify-center items-end !bottom-bottom-base rounded-t-border-radius-md Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-md w-screen fixed Qsmd:relative Qsmd:top-top-base left-left-base z-z-index-header flex-shrink-0 h-[var(--padding-bottom-unassign-cat)]">
              <PrimaryStepper
                activeStep={0}
                handleForwardAction={handleUpdateAccount}
                handleBackwardAction={handleBack}
                dataArray={dataArray}
              />
            </div>
            <div className="w-full flex overflow-y-auto flex-1">
              <TaxAccoountEditStepPAN
                verifiedPan={verifiedPan}
                panNumber={payload.panNumber}
                handlePANChange={handlePANChange}
                panDetails={panDetails}
                verifyPANisLoading={verifyPANisLoading}
                handleGSTChange={handleGSTChange}
                payload={payload}
                GSTStatus={GSTStatus}
                GSTLinked={GSTLinked}
                GSTError={GSTError}
                gstVerified={gstVerified}
                gstDetails={gstDetails}
                isGSTLoading={isGSTLoading}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                taxAccountId={taxAccountId}
                setTaxAccountId={setTaxAccountId}
                taxAccountDetails={taxAccountDetails}
                setTaxAccountDetails={setTaxAccountDetails}
                showPopup={showPopup}
                setShowPopup={setShowPopup}
                haveAcheived={haveAcheived}
                haveApproved={haveApproved}
                haveBlock={haveBlock}
                haveDennied={haveDennied}
                havePending={havePending}
                haveRejected={haveRejected}
                slideDirection={slideDirection}
                setSlideDirection={setSlideDirection}
                isApprovedState={isApprovedState}
                noDetails={noDetails}
                closeGSTDetailsModal={closeGSTDetailsModal}
                beneLookLoading={beneLookLoading}
                isLinkedAccount={isLinkedAccount}
                setIsLinkedAccount={setIsLinkedAccount}
                alreadyLinked={alreadyLinked}
                haveLinkNew={haveLinkNew}
                setIsActive={setIsActive}
                isActive={isActive}
                setIsArchived={setIsArchived}
                setIsApproved={setIsApproved}
                setIsDennied={setIsDennied}
                setIsPending={setIsPending}
                setAccountType={setAccountType}
                setHideBlock={setHideBlock}
                associatedPan={associatedPan}
                prefilledGst={!!prefilledGst}
              />
            </div>
            <div className="h-stepper-moble-height flex Qsmd:hidden"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TaxationAccountEditPAN;
